import index from './index'

test('tests', () => {
  expect(true).toBe(true)
})
